import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
const LessonPlanCreate = () => {
  const navigate = useNavigate();
  const [formCatagery, setFormCatagery] = React.useState("Daily");
  const [weeklyPlan, setWeeklyPlan] = React.useState([1]);
  const addSection = [];
  const AddSectionHandler = () => {
    addSection.push(1);
    setWeeklyPlan([...weeklyPlan, ...addSection]);
  };
  return (
    <SideMenu>
      <div className="page-details-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={10} lg={10} md={8} sm={8} xs={4}>
              <BackHeader backHanler={() => navigate(-1)} />
            </Grid>
            <Grid item xl={1} lg={1} md={2} sm={2} xs={4}>
              <Button
                className="lesson-plan-header-close-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                <p className="page-header-button-text">Cancel</p>
              </Button>
            </Grid>
            <Grid item xl={1} lg={1} md={2} sm={2} xs={4}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                <p className="page-header-button-text">Save</p>
              </Button>
            </Grid>
          </Grid>
          <p className="lesson-plan-create-header-heading">
            Create salary request
          </p>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Select Time</p>
                <select
                  className="input"
                  onChange={(e) => setFormCatagery(e.target.value)}
                >
                  <option value="Daily">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                </select>
              </div>
            </Grid>
            {formCatagery === "Daily" && (
              <>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <div>
                    <p className="input-heading">Date</p>
                    <input type="date" className="input" />
                  </div>
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                  <div>
                    <p className="input-heading">Subject name</p>
                    <select className="input">
                      <option value="">Select</option>
                    </select>
                  </div>
                </Grid>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div>
                    <p className="input-heading">Subject topic</p>
                    <input
                      type="text"
                      className="input"
                      placeholder="Your Subject topic"
                    />
                  </div>
                </Grid>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div>
                    <p className="input-heading">Subject topic Description</p>
                    <textarea
                      className="textarea"
                      placeholder="Subject topic Description"
                      rows="20"
                      cols="40"
                    ></textarea>
                  </div>
                </Grid>
              </>
            )}

            {formCatagery === "Weekly" && (
              <>
                {weeklyPlan.map((weeklyPlanValue, weeklyPlanIndex) => {
                  return (
                    <>
                      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <p className="lesson-plan-day-heading">
                          Day:{weeklyPlanIndex + 1}
                        </p>
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div>
                          <p className="input-heading">Date</p>
                          <input type="date" className="input" />
                        </div>
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div>
                          <p className="input-heading">Subject name</p>
                          <select className="input">
                            <option value="">Select</option>
                          </select>
                        </div>
                      </Grid>
                      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div>
                          <p className="input-heading">Subject topic</p>
                          <input
                            type="text"
                            className="input"
                            placeholder="Your Subject topic"
                          />
                        </div>
                      </Grid>
                      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div>
                          <p className="input-heading">
                            Subject topic Description
                          </p>
                          <textarea
                            className="textarea"
                            placeholder="Subject topic Description"
                            rows="20"
                            cols="40"
                          ></textarea>
                        </div>
                      </Grid>
                    </>
                  );
                })}
                <Grid container spacing={2}>
                  <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Button
                      className="form-button"
                      variant="text"
                      onClick={AddSectionHandler}
                    >
                      Add sections
                    </Button>
                  </Grid>
                  <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
                </Grid>
              </>
            )}

            {formCatagery === "Monthly" && (
              <>
                {weeklyPlan.map((weeklyPlanValue, weeklyPlanIndex) => {
                  return (
                    <>
                      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <p className="lesson-plan-day-heading">
                          Day:{weeklyPlanIndex + 1}
                        </p>
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div>
                          <p className="input-heading">Date</p>
                          <input type="date" className="input" />
                        </div>
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div>
                          <p className="input-heading">Subject name</p>
                          <select className="input">
                            <option value="">Select</option>
                          </select>
                        </div>
                      </Grid>
                      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div>
                          <p className="input-heading">Subject topic</p>
                          <input
                            type="text"
                            className="input"
                            placeholder="Your Subject topic"
                          />
                        </div>
                      </Grid>
                      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div>
                          <p className="input-heading">
                            Subject topic Description
                          </p>
                          <textarea
                            className="textarea"
                            placeholder="Subject topic Description"
                            rows="20"
                            cols="40"
                          ></textarea>
                        </div>
                      </Grid>
                    </>
                  );
                })}
                <Grid container spacing={2}>
                  <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Button
                      className="form-button"
                      variant="text"
                      onClick={AddSectionHandler}
                    >
                      Add sections
                    </Button>
                  </Grid>
                  <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default LessonPlanCreate;
